module.exports = __webpack_public_path__ + "media/images/official/special_double_life_hero-36183c70d36bb29a64f60d17cd586156.webp";